import { H2 } from '@comeon/ui';

import { textKeysNewQDAmountScreenHeader } from '~/components/payment/quick-deposit-beta/components-v2/constants';
import useTranslations from '~/components/translation/use-translations';
import { useCloseCurrentContext } from '~/hooks/use-close-context';

// Styled components
import { CloseButton, Header } from './styles';

type Props = {
	disabled?: boolean;
	textHeading?: string;
};

const NewQuickDepositAmountScreenHeader = ({ disabled, textHeading }: Props) => {
	const closeCurrentContext = useCloseCurrentContext();
	const { translations } = useTranslations(textKeysNewQDAmountScreenHeader);
	const { NEW_QUICK_DEPOSIT_AMOUNT_SCREEN_HEADING } = translations;

	return (
		<Header className="page-head__left-side" disabled={disabled}>
			<H2>{textHeading || NEW_QUICK_DEPOSIT_AMOUNT_SCREEN_HEADING}</H2>
			<CloseButton className="at-icon-close page-head__close" onClick={closeCurrentContext} type="button" />
		</Header>
	);
};

export default NewQuickDepositAmountScreenHeader;
